// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3dRM4","colMin":"styles_colMin__30DbA","colCheckbox":"styles_colCheckbox__b8saC"};